module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "book"
  }, [_c('div', {
    staticClass: "coverInfo"
  }, [_c('img', {
    staticClass: "coverImage",
    attrs: {
      "src": "//textcafe.co/books/klE2ku/tc-custom/cover.jpg?1684514755492?1702529462637",
      "alt": "This image is the cover for the book Pennsylvania Lighthouses on Lake Erie, Landmarks"
    }
  })]), _vm._v(" "), _c('div', {
    staticClass: "bookInfo"
  }, [_c('h1', {
    staticClass: "bookTitle heading font1"
  }, [_vm._v("Pennsylvania Lighthouses on Lake Erie, Landmarks\n    ")]), _vm._v(" "), _c('p', {
    staticClass: "bookDescription body article font2"
  }), _c('p', [_vm._v("Four lighthouses remain  in Pennsylvania, and Lake Erie is home to three. In 1818, Old Presque Isle Light became the first United States lighthouse built on the lake's shore. But a need for even more navigational assistance gave birth to the North Pierhead Lighthouse forty years later. The Presque Isle Light Station first shined on Lake Erie in July 1873. Thanks to the guidance from these landmarks, Erie's port is one of the busiest in the Great Lakes. Author Eugene Ware offers an edifying history of Erie Harbor lights.")]), _vm._v(" "), _c('p')]), _vm._v(" "), _c('div', {
    staticClass: "authorInfo"
  }, [_c('h2', {
    staticClass: "authorName heading font1"
  }, [_vm._v("\n      Eugene H. Ware\n    ")]), _vm._v(" "), _c('p', {
    staticClass: "authorDescription body article"
  }, [_vm._v("Eugene Ware serves as president of the Friends of Tom Ridge Environmental Center and treasurer of the Presque Isle Light Station. He is also an active member of the Historical Society of Erie County. Eugene annually presents over fifty Presque Isle and Erie lectures.")])]), _vm._v(" "), _c('div', {
    staticClass: "publisherInfo"
  }, [_c('h2', {
    staticClass: "publisherName heading font1"
  }, [_vm._v("\n    The History Press\n   ")])])])
}]}


//////////////////
// WEBPACK FOOTER
// ../node_modules/vue-loader/lib/template-compiler?{"id":"data-v-638a3f51","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!../node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/home.vue
// module id = 51
// module chunks = 0